import { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";

import { postMapLandPosition } from "../services/GlobalRoles/postMapLandPosition";
import { useParams } from "react-router-dom";

const MapContext = createContext();

export function MapProvider({ children }) {
  // states
  const [tooltipEnd, setTooltipEnd] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [visibleTooltip, setVisibleTooltip] = useState(false);
  const [tooltipReverse, setTooltipReverse] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState(null);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const [circleSize, setCircleSize] = useState(8);
  const [data, setData] = useState([]);
  const [items, setItems] = useState([]);

  const [panX, setPanX] = useState(0);
  const [panY, setPanY] = useState(0);

  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);

  const [zoom, setZoom] = useState(1);
  const [zoomMove, setZoomMove] = useState(true);

  const [isDragging, setIsDragging] = useState(false);

  const [totalSize, setTotalSize] = useState(0);

  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [positionDragStart, setPositionDragStart] = useState({ x: 0, y: 0 });

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentBlock, setCurrentBlock] = useState(null);
  const [currentLandIndex, setCurrentLandIndex] = useState(0);
  const [empId, setEmpId] = useState(undefined);

  const [googleMapsPosition, setGoogleMapsPosition] = useState(null);

  const [showToolTip, setShowToolTip] = useState(false);
  // request
  async function item(x, y, cBlock, cLand, cColor, cId, cValue, cM2) {
    const newItem = {
      x: x,
      y: y,
      id: cId,
      land: cBlock + cLand,
      color: cColor,
      m2: cM2,
      value: cValue
    };

    const newItems = [...items, newItem];
    setItems(newItems);

    const landPositionData = {
      data: {
        [cId]: {
          cx: x,
          cy: y,
        }
      },
      "size": circleSize,
      "enterprise_id": empId
    };
    await postMapLandPosition(landPositionData);
    //    console.log("Response for xy land: ", sendLandPosition);
    //    console.log("Items: ", newItems);
  }

  function processMapData(mapData) {
    const newItems = [];
    const itemsToPosition = [];

    mapData?.blocks?.forEach((block) => {
      const newBlock = {
        id: block.id,
        name: block.name,
        lands: [],
      };
      block?.lands?.forEach((land) => {
        if (land.cx && land.cy) {
          const itemColor = getColorFromStatus(land.status);
          const newItem = {
            x: parseFloat(land.cx),
            y: parseFloat(land.cy),
            id: land.id,
            land: block.name + "/" + land.name,
            m2: land.m2,
            value: land.value,
            color: itemColor,
          };
          newItems.push(newItem);
        }

        if (!land.cx || !land.cy) {
          newBlock.lands.push({
            id: land.id,
            name: land.name,
            status: land.status,
            m2: land.m2,
            value: land.value,
          });
        }
      });

      if (newBlock.lands.length > 0) {
        itemsToPosition.push(newBlock);
      }
    });

    return { newItems, itemsToPosition };
  }

  const onTemplateRemove = (file, callback) => {
    setTotalSize(totalSize - file.size);
    callback();
  };

  function imageSize(imagem) {
    let largura = imagem.width;
    let altura = imagem.height;

    if (largura >= 1920 && largura <= 2560) {
      largura = largura / 1.8;
      altura = altura / 1.8;
    } else if (largura >= 2560 && largura <= 3840) {
      largura = largura / 2.2;
      altura = altura / 2.2;
    } else if (largura > 3840 && largura <= 5840) {
      largura = largura / 3.6;
      altura = altura / 3.6;
    } else if (largura > 5840 && largura <= 7680) {
      largura = largura / 5;
      altura = altura / 5;
    } else if (largura > 7680) {
      largura = largura / 6;
      altura = altura / 6;
    }

    return { largura, altura };
  }

  const updateCursorPosition = (e) => {
    const stage = e.target.getStage();
    // console.log(stage);
    if (stage) {
      const position = stage.getPointerPosition();
      if (position) {
        const { clientX, clientY } = e.evt;
        let tooltipX = window.innerWidth <= 787 ? clientX : clientX - 250; // Pequeno deslocamento para a direita
        let tooltipY = window.innerWidth <= 787 ? clientY - 80 : clientY - 274;
        // const { clientX, clientY } = position;
        setMouseX(tooltipX);
        setMouseY(tooltipY);
      }
    }
  };

  function generateItems(x, y) {
    if (
      currentBlock &&
      currentBlock.lands[currentLandIndex] &&
      data.blocks.length !== 0 &&
      currentBlock.lands.length !== 0
    ) {
      const blockIndex = currentIndex;
      const landIndex = currentLandIndex;
      const currentLand = currentBlock.lands[landIndex];

      // console.log("Current Block: ", currentBlock)
      // console.log("Current Land: ", currentLand)

      let itemColor;
      //      console.log(currentBlock.lands[landIndex]);
      if (currentBlock.lands[landIndex].status !== undefined) {
        itemColor = getColorFromStatus(currentBlock.lands[landIndex].status);
      }


      if (landIndex < currentBlock.lands.length - 1) {
        item(
          x,
          y,
          currentBlock.name,
          currentLand.name,
          itemColor,
          currentBlock.lands[landIndex].id,
          currentLand.value,
          currentLand.m2,
        );
        setCurrentLandIndex(landIndex + 1);
      } else if (
        blockIndex < data.blocks.length - 1 &&
        currentBlock.lands.length !== 0
      ) {
        item(
          x,
          y,
          currentBlock.name,
          currentLand.name,
          itemColor,
          currentBlock.lands[landIndex].id,
          currentLand.value,
          currentLand.m2,
        );
        setCurrentIndex(blockIndex + 1);
        setCurrentLandIndex(0);
      } else if (
        landIndex === currentBlock.lands.length - 1 &&
        currentBlock.lands.length !== 0
      ) {
        item(
          x,
          y,
          currentBlock.name,
          currentLand.name,
          itemColor,
          currentBlock.lands[landIndex].id,
          currentLand.value,
          currentLand.m2,
        );
        setCurrentLandIndex(landIndex + 1);
      } else {
        //        console.log("FIM");
      }
    }
  }

  // handle functions
  const handleDragStart = (e) => {
    setZoomMove(false);
    setIsDragging(true);
    setPositionDragStart({ x: e.target.x(), y: e.target.y() })
    if (e.target.name()) {
      const id = e.target.name();
      const updatedItems = [...items];
      const item = updatedItems.find((i) => i.id === id);
      const index = updatedItems.indexOf(item);
      updatedItems.splice(index, 1);
      updatedItems.push(item);
      // setItems(updatedItems);
    }
  };

  const handleDragEnd = async (e) => {
    // console.log("End: ", e.target.name());
    if (e.target.x() < 4 || e.target.x() > imageDimensions.width - 4) {
      toast.warn("Posicione a bolinha dentro das dimensões do mapa");
      e.target.setPosition({ x: positionDragStart.x, y: positionDragStart.y });
      setZoomMove(true);
      setIsDragging(false);
      return;
    }
    if (e.target.y() < 4 || e.target.y() > imageDimensions.height - 4) {
      toast.warn("Posicione a bolinha dentro das dimensões do mapa");
      e.target.setPosition({ x: positionDragStart.x, y: positionDragStart.y });
      setZoomMove(true);
      setIsDragging(false);
      return;
    }
    setZoomMove(true);
    setIsDragging(false);
    if (e.target.name()) {
      const id = e.target.name();
      const updatedItems = [...items];
      const item = updatedItems.find((i) => i.id === id);
      const index = updatedItems.indexOf(item);
      const notification = toast.loading("Por favor aguarde...");
      updatedItems[index] = {
        ...item,
        x: e.target.x(),
        y: e.target.y(),
      };
      setItems(updatedItems);

      const landPositionData = {
        data: {
          [id]: {
            cx: e.target.x(),
            cy: e.target.y(),
          }
        },
        size: circleSize,
        enterprise_id: empId
      };
      const sendLandPosition = await postMapLandPosition(landPositionData);

      if (sendLandPosition.success) {
        toast.update(notification, {
          render: sendLandPosition.success.toString(),
          autoClose: 5000,
          type: "success",
          isLoading: false,
        });
      } else {
        toast.update(notification, {
          render:
            "Oops, algo deu errado! Tente atualizar a página e tente novamente.",
          autoClose: 8000,
          type: "error",
          isLoading: false,
        });
      }
    }
  };

  const handleTapCircle = (item, event, subWH, customAction, setTestId) => {
    const { clientX, clientY } = event.evt; // Coordenadas do clique
    console.log({ event })
    const tooltipSize = { width: 200, height: 140 }
    const padding = 10; // Espaço mínimo dos limites da tesla
    switch (customAction) {
      case "simulator":
        if (item.color === "#33FF3C") {
          //          // console.log("Item: ", item);
          setTestId(item.id);
        } else {
          toast.warning("Não disponível para simulação!");
          return;
        }
        break;
      default:
        // Calcula a posição inicial do tooltip
        // console.log("Event: ", event.evt);
        let tooltipX = window.innerWidth <= 787 ? event.evt.layerX : event.evt.layerX - subWH.x; // Pequeno deslocamento para a direita
        let tooltipY = window.innerWidth <= 787 ? event.evt.layerY : event.evt.layerY - subWH.y; // Pequeno deslocamento para baixo
        // console.log({ tooltipX, tooltipY });
        // console.log({"EX: ": event.evt.layerX, "EY: ": event.evt.layerY});
        // console.log("Window Width: ", window.innerWidth);
        // console.log("TooltipSize Width: ", tooltipSize.width);
        // console.log("TooltipSize tooltipX + tooltipSize.width: ", tooltipX + tooltipSize.width);
        // console.log("Padding: ", padding);
        // console.log("SubWH", subWH);
        // Ajusta se ultrapassar o lado direito da tela
        console.log(window.innerWidth);
        console.log("TooltipX: ", tooltipX);
        console.log("Tooltip W: ", tooltipSize.width);
        if ((window.innerWidth <= 787) && tooltipX + tooltipSize.width > window.innerWidth) {
          tooltipX = tooltipX - tooltipSize.width + 36;
        }

        if (tooltipY < tooltipSize.height) {
          tooltipY = tooltipY + tooltipSize.height + 24;
        }

        // Ajusta se ultrapassar o lado inferior da tela
        // if (tooltipY + tooltipSize.height > window.innerHeight) {
        //   tooltipY = clientY - tooltipSize.height - padding;
        // }

        // Ajusta se ultrapassar o lado esquerdo da tela
        // if (tooltipX < tooltipSize.width) {
        //   tooltipX = tooltipX + tooltipSize.width + padding;
        // }

        // Ajusta se ultrapassar o topo da tela
        // if (tooltipY < tooltipSize.height) {
        //   tooltipY = tooltipY + tooltipSize.height + padding;
        // }

        setTooltipPosition({ left: tooltipX, top: tooltipY });
        setVisibleTooltip(true);
        setSelectedItem(item);
        break;
    }
  };

  const handlePan = (dx, dy) => {
    setPanX(panX + dx);
    setPanY(panY + dy);
  };

  const handleMouseMove = (e) => {
    if (isDragging && zoomMove && zoom > 1) {
      const dx = e.clientX - dragStart.x;
      const dy = e.clientY - dragStart.y;
      handlePan(dx, dy);
      setDragStart({ x: e.clientX, y: e.clientY });
    }
  };

  const handleMouseUp = () => {
    if (zoomMove === true) {
      setIsDragging(false);
    }
  };

  const handleMouseDown = (e) => {
    if (zoomMove === true) {
      setIsDragging(true);
      setDragStart({ x: e.clientX, y: e.clientY });
    }
  };

  const handleCanvasClick = (e) => {
    e.evt.preventDefault();
    const stage = e.target.getStage();
    console.log(e);
    if (stage) {
      const position = stage.getPointerPosition();
      if (position) {
        const { x, y } = position;
        generateItems(x, y);
      }
    }
  };

  function getColorFromStatus(status) {
    switch (status) {
      case 0:
        return "#FFD133"; // Cor para status 0
      case 1:
        return "#33FF3C"; // Cor para status 1
      case 2:
        return "#FF3333"; // Cor para status 2
      case 3:
        return "#5D5858"; // Cor para status 3
      default:
        return "#6278F7"; // Cor padrão
    }
  }

  return (
    <MapContext.Provider
      value={{
        handlePan,
        handleMouseUp,
        handleMouseMove,
        handleMouseDown,
        handleTapCircle,
        handleCanvasClick,
        getColorFromStatus,
        visibleTooltip,
        setVisibleTooltip,
        selectedItem,
        setSelectedItem,
        tooltipPosition,
        panX,
        panY,
        setPanX,
        setPanY,
        zoom,
        setZoom,
        currentBlock,
        setCurrentBlock,
        currentLandIndex,
        setCurrentLandIndex,
        currentIndex,
        data,
        setData,
        items,
        setItems,
        onTemplateRemove,
        setTotalSize,
        handleDragEnd,
        handleDragStart,
        updateCursorPosition,
        mouseX,
        mouseY,
        imageSize,
        processMapData,
        tooltipReverse,
        setTooltipReverse,
        tooltipEnd,
        setTooltipEnd,
        imageDimensions,
        setImageDimensions,
        circleSize, setCircleSize,
        empId, setEmpId,
        googleMapsPosition, setGoogleMapsPosition,
        zoomMove, setZoomMove,
        showToolTip, setShowToolTip
      }}
    >
      {children}
    </MapContext.Provider>
  );
}

export function useMapContext() {
  return useContext(MapContext);
}
